import { PageHeader } from "../components/layout/PageHeader";
import { Mail, Plus, Eye, MousePointer, Send, Users, Wand2 } from "lucide-react";

const CAMPAIGNS = [
  { id: "e1", name: "Webinar Reminders · Day-of", status: "scheduled", sends: 1240, opens: 612, clicks: 198, sent: "Tomorrow 9:00" },
  { id: "e2", name: "Cart Close Sequence", status: "live", sends: 4820, opens: 2410, clicks: 932, sent: "Active" },
  { id: "e3", name: "Lead Magnet Delivery", status: "live", sends: 8400, opens: 4920, clicks: 1820, sent: "Active" },
  { id: "e4", name: "Replay · 24hr window", status: "draft", sends: 0, opens: 0, clicks: 0, sent: "Draft" },
];

const TEMPLATES = [
  "Nurture sequence", "Webinar reminders", "Replay sequence", "Book launch",
  "Lead magnet delivery", "Challenge emails", "Cart open sequence", "Cart close sequence",
];

export default function Email() {
  return (
    <div data-testid="email-page" className="space-y-8">
      <PageHeader
        kicker="Reach · Email"
        title="Email campaigns"
        description="AI subject lines, body, blocks, and personalization — sent through Mailgun, SendGrid, SES, or Resend."
        actions={
          <button
            data-testid="email-new-btn"
            className="inline-flex items-center gap-2 px-4 h-11 rounded-xl pl-btn-aqua text-sm"
          >
            <Plus className="h-4 w-4" /> New Campaign
          </button>
        }
      />

      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        <Stat icon={Send} label="Sent (30d)" value="14,486" />
        <Stat icon={Eye} label="Open rate" value="48.2%" />
        <Stat icon={MousePointer} label="Click rate" value="9.7%" />
        <Stat icon={Users} label="Active subscribers" value="6,842" />
      </div>

      <section className="grid grid-cols-1 lg:grid-cols-3 gap-4">
        <div className="lg:col-span-2 rounded-2xl p-5 border border-[var(--pl-border)] bg-[var(--pl-surface)]/60">
          <div className="text-[10px] uppercase tracking-[0.22em] text-[var(--pl-aqua)]">Active Campaigns</div>
          <div className="mt-3 divide-y divide-[var(--pl-border)]">
            {CAMPAIGNS.map((c) => (
              <div
                key={c.id}
                data-testid={`email-campaign-${c.id}`}
                className="py-3 flex items-center gap-3"
              >
                <div className="h-9 w-9 rounded-xl bg-[var(--pl-aqua)]/10 border border-[var(--pl-aqua)]/30 grid place-items-center">
                  <Mail className="h-4 w-4 text-[var(--pl-aqua)]" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="text-sm text-[var(--pl-text)] truncate">{c.name}</div>
                  <div className="text-[11px] text-[var(--pl-text-muted)]">
                    {c.sends.toLocaleString()} sent · {c.opens.toLocaleString()} opens · {c.clicks.toLocaleString()} clicks
                  </div>
                </div>
                <div className="hidden sm:block text-[11px] font-mono text-[var(--pl-text-muted)]">{c.sent}</div>
                <span
                  className={`text-[10px] px-2 py-0.5 rounded-md capitalize border ${
                    c.status === "live"
                      ? "bg-emerald-500/10 border-emerald-500/40 text-emerald-300"
                      : c.status === "scheduled"
                      ? "bg-[var(--pl-aqua)]/10 border-[var(--pl-aqua)]/40 text-[var(--pl-aqua)]"
                      : "bg-white/5 border-[var(--pl-border)] text-[var(--pl-text-muted)]"
                  }`}
                >
                  {c.status}
                </span>
              </div>
            ))}
          </div>
        </div>

        <div className="rounded-2xl p-5 border border-[var(--pl-border)] bg-[var(--pl-surface)]/60">
          <div className="text-[10px] uppercase tracking-[0.22em] text-[var(--pl-aqua)]">AI Templates</div>
          <div className="mt-3 space-y-1.5">
            {TEMPLATES.map((t) => (
              <div
                key={t}
                data-testid={`email-tpl-${t}`}
                className="flex items-center gap-2 px-3 py-2 rounded-xl border border-[var(--pl-border)] bg-white/[0.03] hover:border-[var(--pl-aqua)]/40 cursor-pointer text-sm text-[var(--pl-text)]"
              >
                <Wand2 className="h-4 w-4 text-[var(--pl-aqua)]" /> {t}
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

function Stat({ icon: I, label, value }) {
  return (
    <div className="rounded-2xl p-4 border border-[var(--pl-border)] bg-[var(--pl-surface)]/60">
      <div className="flex items-center gap-2 text-[var(--pl-text-muted)]">
        <I className="h-4 w-4 text-[var(--pl-aqua)]" />
        <div className="text-[10px] uppercase tracking-[0.22em]">{label}</div>
      </div>
      <div className="font-display text-2xl font-semibold mt-1.5 text-[var(--pl-text)]">{value}</div>
    </div>
  );
}
